<template>
    <main-content>
        <customer-format-filter :action="filterAction"></customer-format-filter>
        <div v-if="$can('manage', 'pardakht-shakhsi')">
            <kt-datatable
                ref="datatable"
                v-bind="datatablePropsWithManage"
            ></kt-datatable>
        </div>
        <div v-else>
            <kt-datatable
                ref="datatable"
                v-bind="datatableProps"
            ></kt-datatable>
        </div>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content';
import Filter from './components/filter_customer_format.vue';
import { ShopApiUrl } from '@/common/api.service';
import { AuthorizationHeader } from '@/common/jwt.service';
import columns from './datatable/columns_customer_formats';
import actionsColumn from './components/actions-column-customer-format.vue';

export default {
    name: 'customer-formats',
    components: {
        'main-content': mainContent,
        'customer-format-filter': Filter,
    },
    data() {
        return {
            query: {}
        };
    },
    computed: {
        datatablePropsWithManage() {
            return {
                id: 'datatableWithManageAccess',
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ShopApiUrl.path(
                                'customer/format/admin'
                            ),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data
                            },
                            params: this.query
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true
                },
                layout: {},
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            };
        },
        datatableProps() {
            return {
                id: 'datatable',
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ShopApiUrl.path('customer/format'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data;
                            },
                            params: this.query
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true
                },
                layout: {},
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            };
        }
    },
    methods: {
        filterAction(e, query) {
            this.query = query;
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        }
    },
    mounted() {
    }
};
</script>